import { Component, OnInit, OnDestroy, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Import all components
import { ProductListComponent } from '../components/product-list/product-list.component';
import { TENANTS_INFO } from '@fitness-force/state';

@Component({
  selector: 'lib-retail-billing',
  standalone: true,
  imports: [
    TranslateModule,
    ProductListComponent
],
  template: `
    <div class="retail-billing-container">
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="text-3xl font-medium text-900 mb-3">
          {{ 'RETAIL_BILLING.TITLE' | translate }}
        </div>
        <div class="text-500 mb-5">
          Manage your retail products, SKUs, categories, and brands
        </div>
        
        <!-- Main Product Management Component -->
        <lib-product-list />
      </div>
    </div>
  `,
  styles: [`
    .retail-billing-container {
      padding: 1rem;
    }
  `]
})
export class RetailBillingComponent implements OnInit, OnDestroy {
  private store = inject(Store);

  tenantId?: number;
  companyLevel: boolean = true;
  tenantInfo$: Observable<any>;
  private destroy$ = new Subject<void>();

  constructor() {
    this.tenantInfo$ = this.store.select(TENANTS_INFO);
  }

  ngOnInit(): void {
    this.tenantInfo$
      .pipe(takeUntil(this.destroy$))
      .subscribe((tenantInfo) => {
        if (tenantInfo?.selected_tenant) {
          this.tenantId = tenantInfo.selected_tenant.id;
          this.companyLevel = true; // Default to company level
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}